import React from 'react';
import {ClickableText} from "../custom-common";

const linkStyle = {
    marginTop: 30,
    margin: '16px 0px',
}

const UseDifferentPaymentMethod = ({hideMethod, strings}) => (
    <div style={linkStyle}>
        <ClickableText onClick={hideMethod} small>{strings.useDifferentPaymentMethod}</ClickableText>
    </div>
);

export default UseDifferentPaymentMethod;